import { IOption } from "models/Form";

export const TERMS_OF_SERVICE = `https://haulpay.io/tos/`;

export const BUSINESS_TYPES: IOption[] = [
  { id: 1, label: "Carrier", value: "carrier" },
  { id: 2, label: "Broker", value: "broker" },
  { id: 3, label: "Shipper", value: "shipper" },
  { id: 4, label: "Carrier/Broker", value: "broker" },
  { id: 5, label: "Dispatch Company", value: "dispatcher" }
];

export const NUMBER_UNSUPPORTED_TYPES = ["shipper", "dispatcher"];

export const VEHICLE_NUMBER_TYPES: IOption[] = [
  { id: 1, label: "MC", value: "mc" },
  { id: 2, label: "DOT", value: "dot" }
];

export const EQUIPMENT_TYPES = [
  { id: 1, label: "Dry Van (V)", subLabel: "Dry Van", value: "V" },
  { id: 2, label: "Flatbed (F)", subLabel: "Flatbed", value: "F" },
  { id: 3, label: "Reefer (R)", subLabel: "Reefer", value: "R" },
  { id: 4, label: "Auto Carrier (AC)", subLabel: "Auto Carrier", value: "AC" },
  { id: 5, label: "B Train Flatbed (BT)", subLabel: "B Train Flatbed", value: "BT" },
  { id: 6, label: "Cargo Van (CV)", subLabel: "Cargo Van", value: "CV" },
  { id: 7, label: "Curtain Van (VC)", subLabel: "Curtain Van", value: "VC" },
  { id: 8, label: "Double Drop (DD)", subLabel: "Double Drop", value: "DD" },
  { id: 9, label: "Drayage (DR)", subLabel: "Drayage", value: "DR" },
  { id: 10, label: "Dump Trailer (DT)", subLabel: "Dump Trailer", value: "DT" },
  { id: 11, label: "Flatbed Hazmat (FZ)", subLabel: "Flatbed Hazmat", value: "FZ" },
  { id: 12, label: "Flatbed Maxi (MX)", subLabel: "Flatbed Maxi", value: "MX" },
  { id: 13, label: "Hopper Bottom (HB)", subLabel: "Hopper Bottom", value: "HB" },
  { id: 14, label: "Hot Shot (HS)", subLabel: "Hot Shot", value: "HS" },
  { id: 15, label: "Low Boy (LB)", subLabel: "Low Boy", value: "LB" },
  { id: 16, label: "Power Only (PO)", subLabel: "Power Only", value: "PO" },
  { id: 17, label: "Rail Container (RC)", subLabel: "Rail Container", value: "RC" },
  { id: 18, label: "Reefer Intermodal (RN)", subLabel: "Reefer Intermodal", value: "RN" },
  { id: 19, label: "Reefer Hazmat (RZ)", subLabel: "Reefer Hazmat", value: "RZ" },
  { id: 20, label: "RGN Flatbed (RGN)", subLabel: "RGN Flatbed", value: "RGN" },
  { id: 21, label: "Step Deck (SD)", subLabel: "Step Deck", value: "SD" },
  { id: 22, label: "Straight Truck (ST)", subLabel: "Straight Truck", value: "ST" },
  { id: 23, label: "Tanker (T)", subLabel: "Tanker", value: "T" },
  { id: 24, label: "Van Intermodal (VN)", subLabel: "Van Intermodal", value: "VN" },
  { id: 25, label: "Van HazMat (VZ)", subLabel: "Van HazMat", value: "VZ" },
  { id: 26, label: "Van Walking Floor (WLK)", subLabel: "Van Walking Floor", value: "WLK" },
  { id: 27, label: "Vented Van (VV)", subLabel: "Vented Van", value: "VV" },
  { id: 28, label: "Container", subLabel: "", value: "CO" },
  { id: 29, label: "Other", subLabel: "", value: "other" }
];

export const LANGUAGE_LIST: IOption[] = [
  { id: 1, label: "English", value: "en" },
  { id: 2, label: "Spanish", value: "es" }
];

export const STEP_LIST = [
  { id: 1, name: "User" },
  { id: 2, name: "Business" },
  { id: 3, name: "Confirmation" }
];
